export default [
  {
    imgURL: "aveva-pic.png",
    imgAlt: "Aveva landing page image.",
    pjName: "Aveva, Internship",
    pjDescription:
      "Developed multiple tools for management and QA engineers.",
    pjPreviewURL: "https://www.aveva.com/en/",
    pjGitHubURL: null,
    techUsed: [
      "C#",
      ".NET",
      "WFA",
      "Multithreading",
      "Git",
      "Git",
      "MVVM",
      "Azure DevOps",
      "Jira",
    ],
  },
  {
    imgURL: "avocore-pic.png",
    imgAlt: "Avocore landing page image.",
    pjName: "Avocore, Internship",
    pjDescription:
      "Built a Chrome extension to increase the productivity of Amazon sellers.",
    pjPreviewURL: "https://avocore.com/",
    pjGitHubURL: null,
    techUsed: [
      "Chrome Extension",
      "JavaScript",
      "HTML",
      "Git",
      "Documentation",
      "Azure DevOps ",
    ],
  },
  {
    imgURL: "counselHero-pic.png",
    imgAlt: "counsel hero landing page image.",
    pjName: "CounselHero, Internship",
    pjDescription:
      "Worked on an education tool that automates counseling for students.",
    pjPreviewURL: "https://www.counselhero.com/",
    pjGitHubURL: null,
    techUsed: [
      "React",
      "TypeScript",
      "Redux",
      "Boostrap",
      "Figma",
      "CSS",
      "HTML",
      "Git",
      "GitHub",
      "Collaborative Programming",
      "Documentation",
      "Figma",
    ],
  },
  {
    imgURL: "axess-pic.png",
    imgAlt: "axess picture that show how it works",
    pjName: "Axess, Caltech Hackathon (Winner)",
    pjDescription: "Web accessibility education tool for  developers.",
    pjPreviewURL: "https://devpost.com/software/axess",
    pjGitHubURL: "https://github.com/mehmetalperen/axess",
    techUsed: [
      "React",
      "Figma",
      "HTML",
      "CSS",
      "Git",
      "GitHub",
      "Research",
      "Collaborative Programming",
    ],
  },
  {
    imgURL: "chat-mehmet.png",
    imgAlt: "Chat Mehmet application page image.",
    pjName: "ChatMehmet, Hobby",
    pjDescription:
      "A messaging platform for people who would like to get in touch with me.",
    pjPreviewURL: "https://chatmehmetnadi.com/",
    pjGitHubURL: "https://github.com/mehmetalperen/portfolio-chat-frontend",
    techUsed: [
      "React",

      "Firebase Database",
      "Firebase Authentication",
      "Firebase Cloud Funtions",
      "Firebase Hosting",
      "Firebase Hosting",
      "HTML/CSS",
      "Boostrap",
      "Sendgrid",
    ],
  },
  {
    imgURL: "search-engine.png",
    imgAlt: "Search engine preview image.",
    pjName: "Search Engine/School",
    pjDescription: "Led a team to build a search engine from scratch.",
    pjPreviewURL: null,//"https://combinotorial-puzzle-solver.vercel.app/",
    pjGitHubURL: "https://github.com/mehmetalperen/search-engine",
    techUsed: [
      "Python",
      "Data Structures and Algorithm",
      "TF-IDF",
      "Page Ranking",
      "Git", "Git",
      "GitHub",
    ],
  },
  // {
  //   imgURL: "stem-bound-pic.png",
  //   imgAlt: "Stem-bound landing page image.",
  //   pjName: "Stem-bound, Group Project",
  //   pjDescription:
  //     "A platform that connects students with professionals in STEM.",
  //   pjPreviewURL: "https://www.stembound.education/",
  //   pjGitHubURL: "https://github.com/omerdemirkan/stem-bound-client",
  //   techUsed: [
  //     "React",
  //     "TypeScript",
  //     "Material-ui",
  //     "Figma",
  //     "HTML",
  //     "CSS",
  //     "Git",
  //     "GitHub",
  //     "Collaborative Programming",
  //   ],
  // },
  {
    imgURL: "shell.png",
    imgAlt: "Shell Screenshot.",
    pjName: "Shell, Group Project",
    pjDescription:
      "Custom shell program in C for command-line interaction with the operating system.",
    pjPreviewURL: null,
    pjGitHubURL: "https://github.com/mehmetalperen/Shell",
    techUsed: [
      "C",
      "Computer Science",
      "Git",
      "GitHub",
      "Collaborative Programming",
    ],
  },
  {
    imgURL: "combination-solver.png",
    imgAlt: "Combination puzzle solver app preview image.",
    pjName: "Combination Puzzle Solver, Hobby/School",
    pjDescription: "Visualizing recursive algorithm learned at school.",
    pjPreviewURL: "https://combinotorial-puzzle-solver.vercel.app/",
    pjGitHubURL: "https://github.com/mehmetalperen/combinotorial-puzzle-solver",
    techUsed: [
      "React",
      "Data Structures and Algorithm",
      "Recursion",
      "Boostrap",
      "Figma",
      "HTML",
      "CSS",
      "Git",
      "GitHub",
    ],
  },
  // {
  //   imgURL: "tic-tac-toe.png",
  //   imgAlt: "Tic tac toe game picture",
  //   pjName: "Multiplayer tic-tac-toe, Hobby",
  //   pjDescription:
  //     "Multiplayer tic-tac-toe game with realtime firebase database.",
  //   pjPreviewURL: "https://tic-tac-toe-firebase.vercel.app/",
  //   pjGitHubURL: "https://github.com/mehmetalperen/tic-tac-toe-firebase",
  //   techUsed: ["Firebase", "Realtime DB", "Next.js", "Vercel"],
  // },
  {
    imgURL: "word-counter-pic.png",
    imgAlt: "word-counter app picture that show how it works",
    pjName: "WordCounter, Hobby",
    pjDescription: "A word/sentence/paragraph counter.",
    pjPreviewURL: "https://upbeat-aryabhata-595ba2.netlify.app/",
    pjGitHubURL: null, //"https://github.com/mehmetalperen/WordCounter",
    techUsed: ["JavaScript", "HTML", "CSS", "Git", "GitHub"],
  },
  {
    imgURL: "natural-selection.png",
    imgAlt: "natural selection simulation picture that shows how it works",
    pjName: "Natural Selection Simulation, Hobby",
    pjDescription:
      "One of the projects I did for fun. I practiced my OOP skills.",
    pjPreviewURL:
      "https://mehmetalperen.github.io/natural-selection-simulation/",
    pjGitHubURL:
      "https://github.com/mehmetalperen/natural-selection-simulation",
    techUsed: ["JavaScript", "HTML", "CSS", "Git", "GitHub"],
  },
  {
    imgURL: "snake-game-pic.png",
    imgAlt: "snake game picture that shows how it works",
    pjName: "Snake Game, Hobby",
    pjDescription: "Just a regular snake game. Nothing fancy :)",
    pjPreviewURL: "https://mehmetalperen.github.io/snake-game/",
    pjGitHubURL: "https://github.com/mehmetalperen/snake-game",
    techUsed: ["JavaScript", "OOP", "Boostrap", "HTML", "CSS", "Git", "GitHub"],
  },
  {
    imgURL: "universal-commnet.png",
    imgAlt: "Universal Comment figma design",
    pjName: "Universal Comment, Design",
    pjDescription:
      "Chrome extension idea.",
    pjPreviewURL:
      "https://www.figma.com/file/o1OlmEMyRAxDCQyqApP3QT/universal-comment-Chorome-extension?type=design&node-id=0%3A1&mode=design&t=5Q8feSVR6X1i91PY-1",
    pjGitHubURL: null,
    techUsed: ["Figma", "HTML", "CSS", "UI-design"],
  },
  // {
  //   imgURL: "hungary-app-pic.png",
  //   imgAlt: "Picture of an recipe app that shows how it works",
  //   pjName: "Hungry, Hobby",
  //   pjDescription: "A recipe app with simple instructions and video support.",
  //   pjPreviewURL: "https://unruffled-wiles-bb251b.netlify.app/",
  //   pjGitHubURL: "https://github.com/mehmetalperen/recepie-app",
  //   techUsed: ["React", "Material-ui", "HTML", "CSS", "Git", "GitHub"],
  // },
];

/**
 * imgURL
 * imgAlt
 * pjName
 * pjDectiption
 * pjPreviewURL
 * pjGitHubURL
 */
